<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="12" md="12">
        <base-material-card
          icon="mdi-card-text-outline"
          :title="expense_id ? $i18n.t('Edit Expense') : $i18n.t('Add Expense')"
          class="px-3 py-1 small-icon"
        >
          <v-form id="form" v-model="isValid">
            <v-col>
              <!-- <v-container class="py-0"> -->
              <v-row>
                <v-col cols="12" md="6">
                  <z-account-select
                    :disabled="isEdit"
                    :label="$i18n.t('Account')"
                    v-model="expense.accountCode"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  v-if="
                    expense.accountCode &&
                    (expense.accountCode == 'VehicleExpense' ||
                      expense.accountCode == 'DriverExpense')
                  "
                >
                  <v-autocomplete
                    :items="getExpenseList()"
                    :label="$i18n.t('Service Type')"
                    v-model="expense.expenseType"
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row v-if="expense.accountCode">
                <v-col>
                  <v-row>
                    <v-col cols="12" sm="12" md="8" lg="8">
                      <v-card>
                        <v-btn color="grey" small class="expense-headers">
                          <h3>{{ $i18n.t("Expense Details") }}</h3>
                        </v-btn>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                          style="padding: 27px"
                        >
                          <v-row
                            v-show="
                              expense.accountCode != 'DriverCashAdvance' &&
                              expense.accountCode != 'DriverFundReturn' &&
                              expense.accountCode != 'TripExpenseAdvance' &&
                              expense.accountCode != 'TripExpenseReturn' &&
                              expense.accountCode != 'SupplierAdvance' &&
                              expense.accountCode != 'SupplierFundReturn' &&
                              expense.accountCode != 'SalaryAdvance' &&
                              expense.accountCode != 'Salary'
                            "
                          >
                            <v-col cols="12" sm="12" md="6" lg="6">
                              <v-text-field
                                :label="$i18n.t('Bill No.')"
                                v-model="expense.invoiceNo"
                              />
                            </v-col>
                            <v-col cols="12" sm="12" md="6" lg="6">
                              <z-entity-select
                                class="purple-input"
                                v-model="expense.billingEntity_id"
                                corp="self"
                              ></z-entity-select>
                            </v-col>
                          </v-row>

                          <v-row v-if="expense.accountCode == 'VehicleExpense'">
                            <v-col cols="12" sm="12" md="12" lg="12">
                              <z-vehicle-select
                                idOnly
                                :label="$i18n.t('Vehicle')"
                                v-model="expense.vehicle_id"
                              />
                            </v-col>
                          </v-row>

                          <v-row
                            v-show="
                              expense.accountCode == 'DriverCashAdvance' ||
                              expense.accountCode == 'DriverFundReturn' ||
                              expense.accountCode == 'TripExpenseAdvance' ||
                              expense.accountCode == 'TripExpenseReturn' ||
                              expense.accountCode == 'SalaryAdvance' ||
                              expense.accountCode == 'Salary' ||
                              expense.accountCode == 'DriverExpense'
                            "
                          >
                            <v-col cols="12" sm="12" md="12" lg="12">
                              <z-driver-select
                                idOnly
                                :label="$i18n.t('Driver')"
                                v-model="expense.driver_id"
                              />
                            </v-col>
                          </v-row>

                          <v-row v-show="expense.accountCode != 'CreditNote'">
                            <v-col
                              cols="12"
                              sm="12"
                              md="6"
                              lg="6"
                              v-if="
                                (expense.accountCode == 'VehicleExpense' ||
                                  expense.accountCode == 'DriverExpense') &&
                                expense.expenseType == 'Insurance'
                              "
                            >
                              <z-name-master-select
                                :type="4"
                                v-model="expense.insuranceProvider"
                                :label="$i18n.t('Insurance Provider')"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="6"
                              lg="6"
                              v-if="
                                (expense.accountCode == 'VehicleExpense' ||
                                  expense.accountCode == 'DriverExpense') &&
                                expense.expenseType == 'Permits'
                              "
                            >
                              <z-name-master-select
                                :type="5"
                                v-model="expense.title"
                                :label="$i18n.t('Permit Name')"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="6"
                              lg="6"
                              v-if="expense.expenseType != 'Permits'"
                            >
                              <v-text-field
                                :label="$i18n.t(getTitle())"
                                v-model="expense.title"
                              />
                            </v-col>
                            <!-- <z-permit-select
                              v-show="
                                (expense.accountCode == 'VehicleExpense' ||
                                  expense.accountCode == 'DriverExpense') &&
                                expense.expenseType == 'Permits'
                              "
                              :label="$i18n.t('Permit Name')"
                              v-model="expense.title"
                            /> -->
                          </v-row>

                          <v-row v-if="expense.accountCode != 'CreditNote'">
                            <v-col cols="12" sm="6" md="3" lg="3">
                              <z-date-picker
                                :label="$i18n.t(getDateTitle('date'))"
                                v-model="expense.date"
                              />
                            </v-col>

                            <v-col
                              cols="12"
                              sm="6"
                              md="3"
                              lg="3"
                              v-show="
                                expense.accountCode == 'DriverExpense' ||
                                expense.accountCode == 'VehicleExpense' ||
                                expense.accountCode == 'ArticlePurchase' ||
                                expense.accountCode == 'OfficeExpense'
                              "
                            >
                              <z-date-picker
                                :label="$i18n.t(getDateTitle('affectFrom'))"
                                v-model="expense.affectFrom"
                              />
                            </v-col>

                            <v-col
                              cols="12"
                              sm="6"
                              md="3"
                              lg="3"
                              v-show="
                                expense.accountCode == 'DriverExpense' ||
                                expense.accountCode == 'VehicleExpense' ||
                                expense.accountCode == 'ArticlePurchase' ||
                                expense.accountCode == 'OfficeExpense'
                              "
                            >
                              <z-date-picker
                                :label="$i18n.t(getDateTitle('expiry'))"
                                v-model="expense.expiry"
                              />
                            </v-col>

                            <v-col
                              cols="12"
                              sm="6"
                              md="3"
                              lg="3"
                              v-show="
                                expense.accountCode == 'Salary' ||
                                expense.accountCode == 'SalaryAdvance' ||
                                expense.accountCode == 'Rent'
                              "
                            >
                              <z-date-picker
                                :label="$i18n.t('For Month')"
                                v-model="expense.forMonth"
                              />
                            </v-col>
                          </v-row>

                          <v-row v-show="showSupDeductible">
                            <v-checkbox
                              :label="$i18n.t('Supplier Deductible')"
                              v-model="expense.supplierDeductible"
                            ></v-checkbox>
                          </v-row>

                          <v-row
                            v-show="
                              expense.accountCode == 'VehicleExpense' &&
                              expense.expenseType == 'Maintenance'
                            "
                          >
                            <v-col cols="12" sm="6" md="3" lg="3">
                              <v-text-field
                                :label="$i18n.t('Service Kms Reading')"
                                v-model="expense.kms"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="12" sm="6" md="3" lg="3">
                              <z-date-picker
                                :label="$i18n.t('Next Service Date')"
                                v-model="expense.nextServiceDate"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="12" sm="6" md="3" lg="3">
                              <v-text-field
                                :label="$i18n.t('Next Service Kms')"
                                v-model="expense.nextServiceKM"
                                type="number"
                              />
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-textarea
                              :label="$i18n.t('Details')"
                              v-model="expense.serviceDescription"
                            />
                          </v-row>

                          <v-row
                            v-show="
                              expense.accountCode != 'CreditNote' &&
                              expense.accountCode != 'OfficeExpense' &&
                              expense.accountCode != 'DriverFundReturn' &&
                              expense.accountCode != 'TripExpenseAdvance' &&
                              expense.accountCode != 'TripExpenseReturn' &&
                              expense.accountCode != 'SalaryAdvance' &&
                              expense.accountCode != 'Salary' &&
                              expense.accountCode != 'DriverCashAdvance'
                            "
                          >
                            <z-vendor-select
                              :label="$i18n.t(getVendorTitle())"
                              v-model="expense.vendor_id"
                              :other="true"
                              :disabled="disableVendor"
                            ></z-vendor-select>

                            <v-col cols="12" sm="12" md="3" lg="3" v-show="expense.accountCode == 'VehicleExpense' && expense.expenseType == 'Permits'">
                              <v-checkbox
                                :label="$i18n.t('Notify for Renewable')"
                                v-model="expense.notify"
                              ></v-checkbox>
                            </v-col>
                          </v-row>

                          <v-row
                            v-show="
                              expense.vendor_id == 'null' &&
                              expense.accountCode != 'CreditNote'
                            "
                          >
                            <v-col cols="12" sm="12" md="6" lg="6">
                              <v-text-field
                                :label="$i18n.t('Organization Name')"
                                v-model="expense.organization.name"
                                :disabled="disableVendor"
                              />
                            </v-col>
                            <v-col cols="12" sm="12" md="6" lg="6">
                              <v-text-field
                                :label="$i18n.t('Tax ID')"
                                v-model="expense.organization.taxId"
                                :disabled="disableVendor"
                              />
                            </v-col>
                            <!-- <v-col cols="12" sm="12" md="6" lg="6">
                              <v-text-field
                                :label="$i18n.t('Contact Name')"
                                v-model="expense.organization.contact.name"
                              />
                            </v-col>
                            <v-col cols="12" sm="12" md="6" lg="6">
                              <v-text-field
                                :label="$i18n.t('Contact Email')"
                                v-model="expense.organization.contact.email"
                              />
                            </v-col>
                            <v-col cols="12" sm="12" md="6" lg="6">
                              <z-country-select
                                isd
                                :label="$i18n.t('Country Code')"
                                v-model="
                                  expense.organization.contact.countryCode
                                "
                              ></z-country-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="6" lg="6">
                              <v-text-field
                                :label="$i18n.t('Contact Phone')"
                                v-model="expense.organization.contact.phone"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="12" sm="12" md="6" lg="6">
                              <z-country-select
                                :label="$i18n.t('Country')"
                                v-model="expense.organization.address.country"
                              ></z-country-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="6" lg="6">
                              <z-city-select
                                :label="$i18n.t('City')"
                                :country="expense.organization.address.country"
                                v-model="expense.organization.address.city"
                              ></z-city-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" lg="12">
                              <v-text-field
                                :label="$i18n.t('Address Line')"
                                v-model="
                                  expense.organization.address.addressLine
                                "
                              />
                            </v-col> -->
                          </v-row>

                          <v-row v-show="expense.accountCode == 'CreditNote'">
                            <v-col cols="12" sm="12" md="6" lg="6">
                              <z-client-select
                                withSelf
                                :label="$i18n.t('Credit Note For Client')"
                                v-model="expense.client_id"
                              ></z-client-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="6" lg="6">
                              <z-entity-select
                                :label="$i18n.t('Client Entity')"
                                :corp="expense.client_id"
                                v-model="expense.clientEntity_id"
                              ></z-entity-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="6" lg="6">
                              <z-entity-select
                                :label="$i18n.t('Serving Entity')"
                                :corp="webcontent.corp_id"
                                v-model="expense.servingEntity_id"
                              ></z-entity-select>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-card>
                    </v-col>

                    <v-col cols="12" sm="12" md="4" lg="4">
                      <v-card>
                        <v-btn color="grey" small class="expense-headers">
                          <h3>{{ $i18n.t("Attachments") }}</h3>
                        </v-btn>
                        <v-row style="padding: 10px 10px">
                          <v-file-input
                            chips
                            :label="$i18n.t('Attachment')"
                            @change="handleFileUpload()"
                            v-model="file"
                          ></v-file-input>
                        </v-row>
                        <v-row style="padding: 10px 10px">
                          <v-container class="fill-height" fluid>
                            <v-fade-transition mode="out-in">
                              <v-row key="0">
                                <v-col
                                  cols="12"
                                  sm="12"
                                  md="12"
                                  lg="12"
                                  v-for="(
                                    picture, index
                                  ) in expense.attachments"
                                  :key="index"
                                >
                                  <v-card>
                                    <z-confirm-button
                                      fab
                                      color="red"
                                      x-small
                                      class="image-remove"
                                      :message="$i18n.t('Remove Image ?')"
                                      @click="removePic(picture.time)"
                                    >
                                      <v-icon>mdi-trash-can-outline</v-icon>
                                    </z-confirm-button>
                                    <a :href="picture.url">
                                      <v-img
                                        v-if="isPDF(picture.url)"
                                        src="@/assets/pdf_format.png"
                                        aspect-ratio="2"
                                        class="grey darken-4"
                                      ></v-img>
                                      <v-img
                                        v-else
                                        :src="picture.url"
                                        aspect-ratio="2"
                                        class="grey darken-4"
                                      ></v-img>
                                    </a>
                                    <v-row class="px-2">
                                      <!-- <v-col cols="12" md="12" lg="12">{{picture.name}}</v-col> -->
                                      <v-col cols="12" md="12" lg="12">
                                        <!-- {{picture.desc}}{{picture.by}}  -->
                                        {{
                                          picture.time
                                            | moment("HH:mm DD MMM YYYY")
                                        }}
                                      </v-col>
                                    </v-row>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </v-fade-transition>
                          </v-container>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row v-show="expense.accountCode == 'ArticlePurchase'">
                    <v-card style="width: 100%">
                      <v-btn color="grey" small class="expense-headers">
                        <h3>{{ $i18n.t("Articles") }}</h3>
                      </v-btn>
                      <v-btn
                        color="blue"
                        x-small
                        style="float: right"
                        v-if="expense.articles.length == 0"
                        @click="expense.articles.push({})"
                        class="expense-headers"
                      >
                        <h3>{{ $i18n.t("Add") }}</h3>
                      </v-btn>
                      <v-simple-table dense>
                        <template>
                          <thead>
                            <tr>
                              <th class="text-left">
                                {{ $i18n.t("Article") }}
                              </th>
                              <th class="text-left">{{ $i18n.t("Units") }}</th>
                              <th class="text-right"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, index) in expense.articles"
                              :key="index"
                            >
                              <td>
                                <z-article-select v-model="item.article_id" />
                              </td>
                              <td>
                                <v-text-field
                                  v-model="item.units"
                                  type="number"
                                />
                              </td>
                              <td>
                                <v-btn
                                  color="red"
                                  text
                                  fab
                                  @click="removeItem(expense.articles, index)"
                                >
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>

                                <v-btn
                                  color="blue"
                                  text
                                  fab
                                  v-if="expense.articles.length == index+1"
                                  @click="expense.articles.push({})"
                                >
                                  <v-icon>mdi-plus</v-icon>
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card>
                  </v-row>

                  <v-row>
                    <v-btn v-if="!showAddionals" color="info" small @click="showAddionals = true">
                      <h3>+ {{ $i18n.t("Add Additional Details") }}</h3>
                    </v-btn>
                    <v-card style="width: 100%" v-if="showAddionals">
                      <v-btn color="grey" small class="expense-headers">
                        <h3>{{ $i18n.t("Fares") }}</h3>
                      </v-btn>
                      <v-row style="padding: 10px">
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-checkbox
                            :label="$i18n.t('Tax Input Credit Available')"
                            v-model="expense.taxInputCredit"
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="12" md="3" lg="3">
                          <z-fund-account-select multiple="false" v-model="expense.fundAC_id" :label="$i18n.t('Fund Account Select')" />
                        </v-col>
                        <v-col cols="12" sm="12" md="3" lg="3">
                          <z-currency-select
                            :label="$i18n.t('Currency')"
                            v-model="expense.fare.currency"
                          ></z-currency-select>
                        </v-col>
                      </v-row>

                      <v-row
                        style="padding: 10px"
                        v-if="!expense.items || expense.items.length < 1"
                      >
                        <v-col cols="12" sm="12" md="2" lg="2">
                          <v-text-field
                            :label="$i18n.t('Subtotal')"
                            v-model="expense.fare.subTotal"
                            @change="totalFareByTax(expense)"
                            type="number"
                          />
                        </v-col>
                        <v-col cols="12" sm="12" md="2" lg="2">
                          <v-checkbox
                            :label="$i18n.t('Fare includes Taxes')"
                            v-model="expense.fareIncludeTax"
                            @change="totalFareByTax(expense)"
                          ></v-checkbox>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="2"
                          lg="2"
                          v-if="!expense.fareIncludeTax"
                        >
                          <v-select
                            :items="taxSlabs"
                            :label="$i18n.t('Tax Slab')"
                            v-model="expense.tax_id"
                            @change="totalFareByTax(expense)"
                            item-text="name"
                            item-value="_id"
                          />
                        </v-col>
                        <v-col cols="12" sm="12" md="2" lg="2">
                          <v-text-field
                            :label="$i18n.t('Total Fare')"
                            v-model="expense.fare.total"
                            type="number"
                          />
                        </v-col>
                        <v-col cols="12" sm="12" md="2" lg="2">
                          <v-btn text @click="expense.items.push({})">
                            <v-icon>mdi-plus</v-icon>Add Fare Items
                          </v-btn>
                        </v-col>
                      </v-row>

                      <v-row v-if="expense.items.length > 0">
                        <v-card
                          class="py-0 my-2"
                          elevation="1"
                          color="blue lighten-5 d-none d-md-flex"
                          style="width: 100%; margin: 20px"
                        >
                          <v-card-text class="py-0" style="font-size: 12px">
                            <v-row>
                              <v-col cols="12" md="1" lg="1">
                                {{ $i18n.t("Type") }}
                              </v-col>
                              <v-col cols="12" md="1" lg="2">
                                {{ $i18n.t("Title") }}
                              </v-col>
                              <v-col cols="12" md="1" lg="1">
                                {{ $i18n.t("Unit Cost") }}
                              </v-col>
                              <v-col cols="12" md="1" lg="1">
                                {{ $i18n.t("Units") }}
                              </v-col>
                              <v-col cols="12" md="1" lg="1">
                                {{ $i18n.t("Cost") }}
                              </v-col>
                              <v-col cols="12" md="1" lg="2">
                                {{ $i18n.t("Tax") }}
                              </v-col>
                              <v-col cols="12" md="1" lg="1">
                                {{ $i18n.t("Tax Amount") }}
                              </v-col>
                              <v-col cols="12" md="1" lg="2">
                                {{ $i18n.t("Total") }}
                              </v-col>
                              <v-col cols="12" md="1" lg="1">
                                {{ $i18n.t("Action") }}
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                        <v-card style="width: 100%; margin: 0px 20px">
                          <v-card-text
                            class="py-0"
                            v-for="(item, index) in expense.items"
                            :key="index"
                          >
                            <v-row>
                              <v-col cols="12" md="1" lg="1" class="body-2">
                                <v-select
                                  :items="[
                                    { name: 'Part', value: 1 },
                                    { name: 'Labour', value: 2 },
                                  ]"
                                  item-text="name"
                                  item-value="value"
                                  v-model="item.type"
                                  :placeholder="$i18n.t('Type')"
                                />
                              </v-col>
                              <v-col cols="12" md="1" lg="2" class="body-2">
                                <v-text-field
                                  v-model="item.title"
                                  :placeholder="$i18n.t('Title')"
                                />
                              </v-col>
                              <v-col cols="12" md="1" lg="1" class="body-2">
                                <v-text-field
                                  v-model="item.unitCost"
                                  type="number"
                                  :placeholder="$i18n.t('Unit Cost')"
                                  @change="itemCostByUnits(item)"
                                />
                              </v-col>
                              <v-col cols="12" md="1" lg="1" class="body-2">
                                <v-text-field
                                  v-model="item.units"
                                  type="number"
                                  :placeholder="$i18n.t('Units')"
                                  @change="itemCostByUnits(item)"
                                />
                              </v-col>
                              <v-col
                                cols="12"
                                md="1"
                                lg="1"
                                class="body-2"
                                style="padding: 20px"
                              >
                                <span style="font-size: 15px">
                                  {{ item.cost }}
                                </span>
                              </v-col>
                              <v-col cols="12" md="1" lg="2" class="body-2">
                                <v-row>
                                  <v-col cols="12" md="6" lg="6">
                                    <v-text-field
                                      v-model="item.tax"
                                      type="number"
                                      :placeholder="$i18n.t('Tax')"
                                      @change="itemTaxAmount(item)"
                                    />
                                  </v-col>
                                  <v-col cols="12" md="6" lg="6">
                                    <toggle-button
                                      v-model="item.isAbs"
                                      :labels="{
                                        checked: '/-',
                                        unchecked: '%',
                                      }"
                                      class="my-6"
                                      :height="25"
                                      :width="70"
                                      :font-size="14"
                                      @change="itemTaxAmount(item)"
                                    />
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col
                                cols="12"
                                md="1"
                                lg="1"
                                class="body-2"
                                style="padding: 23px"
                              >
                                <span style="font-size: 15px">
                                  {{ item.taxAmount }}
                                </span>
                              </v-col>
                              <v-col
                                cols="12"
                                md="1"
                                lg="2"
                                class="body-2"
                                style="padding: 23px"
                              >
                                <span style="font-size: 15px">
                                  {{ item.total }}
                                </span>
                              </v-col>
                              <v-col cols="12" md="1" lg="1" class="body-2">
                                <v-btn
                                  text
                                  @click="removeItem(expense.items, index)"
                                >
                                  <v-icon>mdi-trash-can-outline</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-divider></v-divider>
                          </v-card-text>
                          <v-card-text class="py-0">
                            <v-row>
                              <v-col
                                cols="12"
                                md="5"
                                lg="5"
                                class="body-2"
                              ></v-col>
                              <v-col cols="12" md="2" lg="2" class="body-2">
                                Sub Total:
                                <b>
                                  {{ expense.fare.subTotal }}
                                  {{ expense.fare.currency }}
                                </b>
                              </v-col>
                              <v-col
                                cols="12"
                                md="1"
                                lg="1"
                                class="body-2"
                              ></v-col>
                              <v-col cols="12" md="1" lg="1" class="body-2">
                                Total Taxes:
                                <b>
                                  {{ expense.fare.totalTaxes }}
                                  {{ expense.fare.currency }}
                                </b>
                              </v-col>
                              <v-col cols="12" md="2" lg="2" class="body-2">
                                Total:
                                <b>
                                  {{ expense.fare.total }}
                                  {{ expense.fare.currency }}
                                </b>
                              </v-col>
                              <v-col
                                cols="12"
                                md="1"
                                lg="1"
                                class="body-2"
                              ></v-col>
                            </v-row>
                            <v-divider></v-divider>
                          </v-card-text>
                          <v-card-text class="py-0">
                            <v-row>
                              <v-col
                                cols="12"
                                md="12"
                                lg="12"
                                class="body-2 text-right"
                              >
                                <v-btn text @click="expense.items.push({})">
                                  <v-icon>mdi-plus</v-icon>Add Items
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-row>
                    </v-card>
                  </v-row>
                </v-col>

                <v-col cols="12">
                  <supplier-payment
                    v-if="expense.corp_id && expense.vendor_id && expense._id"
                    :expense="expense"
                    :hideBills="true"
                    @reload="reload"
                    @setVendorDisable="setVendorDisable"
                  />
                </v-col>

                <v-col cols="12" class="text-right">
                  <v-btn
                    color="cyan"
                    class="mr-10"
                    v-if="isEdit && expense.accountCode == 'CreditNote'"
                    :href="'/api/expense/' + expense_id + '/detail/print'"
                  >
                    <h3>{{ $i18n.t("Print") }}</h3>
                  </v-btn>

                  <v-btn
                    color="green"
                    class="mr-0"
                    v-on:click="save()"
                    :loading="loading"
                  >
                    <h3>{{ $i18n.t("Save") }}</h3>
                  </v-btn>
                </v-col>
              </v-row>
              <!-- </v-card> -->
            </v-col>
            <!-- </v-container> -->
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doPostForm } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import init from "@/store/common/module/init";
import auth from "@/store/user/module/auth";
import SupplierPayment from "@/views/expense/SupplierPayment.vue";

@Component({
  name: "ExpenseEdit",
  components: { SupplierPayment },
  props: {
    singlePage: {
      default: false,
    },
    accountCode: {
      default: null,
    },
    expenseType: {
      default: null,
    },
    entity_id: {
      default: null,
    },
    expenseEdit_id: {
      default: null,
    },
  },
})
export default class ExpenseEdit extends Vue {
  isValid = true;
  isEdit = false;
  file = null;
  expense_id = null;
  disableVendor = null;
  permitTypes = [];
  taxSlabs = [];
  webcontent = {};
  showAddionals = false;
  expensePOSO = {
    fundAC_id:null,
    accountCode: null,
    expenseType: null,
    invoiceNo: null,
    vehicle_id: null,
    driver_id: null,
    servingEntity_id: null,
    client_id: null,
    clientEntity_id: null,
    vendor_id: null,
    supplier_id: null,
    tax_id: null,
    bill_id: null,
    permitName: null,
    permitExp: null,
    permitDate: null,
    insuranceNo: null,
    insuranceDate: null,
    insuranceExp: null,
    serviceDescription: null,
    date: null,
    kms: null,
    nextServiceKM: null,
    nextServiceDate: null,
    taxInputCredit: null,
    fareIncludeTax: null,
    supplierDeductible: null,
    serviceStation: null,
    organization: {
      contact: {},
      address: {},
    },
    items: [],
    fare: { currency: "INR" },
    articles: [],
  };
  expense = this.expensePOSO;

  allServiceTypes = [
    {
      text: "Maintenance/Service",
      value: "Maintenance",
    },
    {
      text: "Tyre",
      value: "Tyre",
    },
    {
      text: "Repair",
      value: "Repair",
    },
    {
      text: "Insurance",
      value: "Insurance",
    },
    {
      text: "RTO Tax",
      value: "RTO Tax",
    },
    {
      text: "Road Tax",
      value: "Road Tax",
    },
    {
      text: "Permits",
      value: "Permits",
    },
    {
      text: "Fitness",
      value: "Fitness",
    },
    {
      text: "PUC",
      value: "PUC",
    },
    {
      text: "Others",
      value: "Others",
    },
  ];

  isPDF(_url) {
    if (_url && _url.includes(".pdf")) {
      return true;
    }
    return false;
  }

  getExpenseList() {
    const expenseTypes = [];
    for (let i = 0; i < this.allServiceTypes.length; i++) {
      if (this.expense.accountCode == "VehicleExpense") {
        expenseTypes.push(this.allServiceTypes[i]);
      } else if (
        this.expense.accountCode == "DriverExpense" &&
        (this.allServiceTypes[i].value == "Permits" ||
          this.allServiceTypes[i].value == "Insurance")
      ) {
        expenseTypes.push(this.allServiceTypes[i]);
      }
    }
    return expenseTypes;
  }

  getVendorTitle() {
    let title = "Vendor/Supplier";
    if (
      this.expense.accountCode == "VehicleExpense" &&
      (this.expense.expenseType == "Permits" ||
        this.expense.expenseType == "PUC" ||
        this.expense.expenseType == "Road tax" ||
        this.expense.expenseType == "Fitness" ||
        this.expense.expenseType == "Insurance")
    ) {
      title = "Issuing Authority";
    }

    return title;
  }

  getTitle() {
    let title = "Title";
    if (this.expense.expenseType == "Maintenance") {
      title = "Service No";
    } else if (this.expense.expenseType == "Repair") {
      title = "Repair No";
    } else if (this.expense.expenseType == "Insurance") {
      title = "Insurance No";
    } else if (this.expense.expenseType == "PUC") {
      title = "PUC No";
    } else if (this.expense.expenseType == "Road Tax") {
      title = "Road Tax";
    } else if (this.expense.expenseType == "Repair") {
      title = "Repair No";
    } else if (this.expense.expenseType == "Permits") {
      title = "Permits";
    } else if (this.expense.expenseType == "Fitness") {
      title = "Fitness";
    } else if (this.expense.expenseType == "Repair") {
      title = "Repair No";
    }

    return title;
  }

  getDateTitle(_for) {
    if (_for == "date") {
      let title = "Date";
      if (
        this.expense.accountCode == "DriverCashAdvance" ||
        this.expense.accountCode == "TripExpenseAdvance" ||
        this.expense.accountCode == "SupplierAdvance"
      ) {
        title = "Cash Advance Date";
      } else if (
        this.expense.accountCode == "DriverFundReturn" ||
        this.expense.accountCode == "TripExpenseReturn" ||
        this.expense.accountCode == "SupplierFundReturn"
      ) {
        title = "Fund Return Date";
      } else if (
        this.expense.accountCode == "DriverExpense" ||
        this.expense.accountCode == "OfficeExpense" ||
        this.expense.accountCode == "VehicleExpense"
      ) {
        title = "Payment Date";
      } else if (this.expense.accountCode == "ArticlePurchase") {
        title = "Purchase Date";
      } else if (this.expense.accountCode == "Salary") {
        title = "Salary Date";
      } else if (this.expense.accountCode == "SalaryAdvance") {
        title = "Advance Salary Date";
      } else if (this.expense.accountCode == "Rent") {
        title = "Rent Date";
      }

      return title;
    } else if (_for == "affectFrom") {
      let title = "Start Date";
      if (
        this.expense.accountCode == "VehicleExpense" &&
        (this.expense.expenseType == "Maintenance" ||
          this.expense.expenseType == "Repair")
      ) {
        title = "Service Start Date";
      } else if (
        (this.expense.accountCode == "VehicleExpense" ||
          this.expense.accountCode == "DriverExpense") &&
        this.expense.expenseType == "Insurance"
      ) {
        title = "Insurance Start Date";
      } else if (
        (this.expense.accountCode == "VehicleExpense" ||
          this.expense.accountCode == "DriverExpense") &&
        this.expense.expenseType == "Permits"
      ) {
        title = "Permit Start Date";
      } else if (
        this.expense.accountCode == "VehicleExpense" &&
        this.expense.expenseType == "Fitness"
      ) {
        title = "Fitness Start Date";
      } else if (
        this.expense.accountCode == "VehicleExpense" &&
        this.expense.expenseType == "PUC"
      ) {
        title = "PUC Start Date";
      } else if (
        this.expense.accountCode == "VehicleExpense" &&
        this.expense.expenseType == "Road Tax"
      ) {
        title = "Road Tax Start Date";
      }

      return title;
    } else if (_for == "expiry") {
      let title = "End Date";
      if (
        this.expense.accountCode == "VehicleExpense" &&
        (this.expense.expenseType == "Maintenance" ||
          this.expense.expenseType == "Repair")
      ) {
        title = "Service End Date";
      } else if (
        (this.expense.accountCode == "VehicleExpense" ||
          this.expense.accountCode == "DriverExpense") &&
        this.expense.expenseType == "Insurance"
      ) {
        title = "Insurance End Date";
      } else if (
        (this.expense.accountCode == "VehicleExpense" ||
          this.expense.accountCode == "DriverExpense") &&
        this.expense.expenseType == "Permits"
      ) {
        title = "Permit End Date";
      } else if (
        this.expense.accountCode == "VehicleExpense" &&
        this.expense.expenseType == "Fitness"
      ) {
        title = "Fitness End Date";
      } else if (
        this.expense.accountCode == "VehicleExpense" &&
        this.expense.expenseType == "PUC"
      ) {
        title = "PUC End Date";
      } else if (
        this.expense.accountCode == "VehicleExpense" &&
        this.expense.expenseType == "Road Tax"
      ) {
        title = "Road Tax End Date";
      }

      return title;
    }

    return "Date";
  }

  get loading() {
    return common.loading;
  }

  async save() {
    try {
      common.setLoading(true);
      const formData = new FormData();
      //this.expense.fundAC_id = "63f34e643b0806799d667236";
      const expenseData = JSON.stringify(this.expense);
      formData.set("data", expenseData);
      if (this.file) {
        formData.append("file", this.file);
      }
      const expense = await doPostForm("/api/expense/save/return", formData);

      if (this.singlePage) {
        this.$emit("closeDialog", true);
        this.$emit("reload", true);
        const e = {};
        this.postFetchDetail(e);
        this.expense = e;
      } else if (!this.expense_id) {
        this.$router.push("/expense/" + expense._id);
      }

      this.expense_id = expense._id;
      this.get();
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  postFetchDetail(_expense) {
    if (!_expense) _expense = {};
    if (!_expense.expenseType) _expense.expenseType = null;
    if (!_expense.invoiceNo) _expense.invoiceNo = null;
    if (!_expense.vehicle_id) _expense.vehicle_id = null;
    if (!_expense.driver_id) _expense.driver_id = null;
    if (!_expense.tax_id) _expense.tax_id = null;
    if (!_expense.permitName) _expense.permitName = null;
    if (!_expense.permitExp) _expense.permitExp = null;
    if (!_expense.permitDate) _expense.permitDate = null;
    if (!_expense.insuranceProvider) _expense.insuranceProvider = null;
    if (!_expense.insuranceNo) _expense.insuranceNo = null;
    if (!_expense.insuranceDate) _expense.insuranceDate = null;
    if (!_expense.insuranceExp) _expense.insuranceExp = null;
    if (!_expense.taxInputCredit) _expense.taxInputCredit = null;
    if (!_expense.fareIncludeTax) _expense.fareIncludeTax = null;
    if (!_expense.supplierDeductible) _expense.supplierDeductible = null;
    if (!_expense.fare) _expense.fare = {};
    if (!_expense.fare.currency) _expense.fare.currency = 'INR';
    if (!_expense.organization) _expense.organization = {};
    if (!_expense.organization.address) _expense.organization.address = {};
    if (!_expense.organization.contact) _expense.organization.contact = {};
    if (!_expense.items) _expense.items = [];
    if (!_expense.articles) _expense.articles = [];
    if (_expense.fare && (_expense.fare.subTotal || _expense.fare.total)) this.showAddionals = true;
  }

  async get() {
    try {
      const expense = await doGet(
        "/api/expense/" + this.expense_id + "/detail"
      );
      this.postFetchDetail(expense);
      this.expense_id = this.expense._id;
      this.isEdit = true;
      this.expense = expense;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async reload(exp) {
    if (exp != null && exp._id) {
      this.expense_id = exp._id;
      await this.get();
    }
  }

  async setVendorDisable(disable) {
    this.disableVendor = disable;
  }

  async removePic(_time) {
    try {
      common.setLoading(true);
      await doGet(
        "/api/expense/" + this.expense_id + "/receipt/" + _time + "/delete"
      );
      this.get();
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  // async fetchPermitTypes() {
  //   this.permitTypes = await doGet("/api/permit/type/all");
  // }
  async fetchTaxSlabs() {
    this.taxSlabs = await doGet("/api/taxslab/all");
  }

  async mounted() {
    await auth.doPostLogin();
    this.webcontent = auth.authContent;

    if (this.singlePage) {
      if (this.expenseEdit_id) {
        this.expense_id = this.expenseEdit_id;
        await this.get();
      } else {
        this.expense._id = null;
        this.expense.currency = "INR";
        this.expense.accountCode = this.accountCode;
        this.expense.expenseType = this.expenseType;
        if (this.accountCode == "VehicleExpense") {
          this.expense.vehicle_id = this.entity_id;
        } else if (this.accountCode == "DriverExpense") {
          this.expense.driver_id = this.entity_id;
        }
      }
    } else if (this.$route.params.id) {
      this.expense_id = this.$route.params.id;
      await this.get();
    }

    await init.getUrlParameter("accountCode");
    if (init.urlParam) {
      this.expense.accountCode = init.urlParam;
    }
    await init.getUrlParameter("expenseType");
    if (init.urlParam) {
      this.expense.expenseType = init.urlParam;
    }
    await init.getUrlParameter("vehicle_id");
    if (init.urlParam) {
      this.expense.vehicle_id = init.urlParam;
    }

    // this.fetchPermitTypes();
    this.fetchTaxSlabs();
  }

  handleFileUpload(files) {
    if (files) {
      this.file = files[0];
    }
  }

  showSupDeductible = false;
  showSupDeduct(veh_id, driver_id) {
    if (
      this.expense.accountCode == "SupplierAdvance" ||
      this.expense.accountCode == "SupplierFundReturn"
    ) {
      if (this.expense.vendor_id) {
        this.showSupDeductible = true;
      }
    } else {
      let _corp_id = null;
      if (this.vehicleOptions && this.vehicleOptions.length > 0 && veh_id) {
        for (
          let i = 0;
          i < this.vehicleOptions.length && _corp_id == null;
          i++
        ) {
          if (this.vehicleOptions[i]._id == veh_id) {
            _corp_id = this.vehicleOptions[i].corp_id;
          }
        }
      }
      if (this.driverOptions && this.driverOptions.length > 0 && driver_id) {
        for (
          let i = 0;
          i < this.driverOptions.length && _corp_id == null;
          i++
        ) {
          if (this.driverOptions[i]._id == driver_id) {
            _corp_id = this.driverOptions[i].driverOf;
          }
        }
      }
      if (this.expense.onBehalf || _corp_id) {
        if (this.expense.onBehalf && this.corp_id != this.expense.onBehalf) {
          this.showSupDeductible = true;
        }
        if (_corp_id && this.webcontent.corp_id != _corp_id) {
          this.showSupDeductible = true;
        }
      }
      // $scope.showSupDeductible = false;
    }
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  itemCostByUnits(item) {
    if (this.isSet(item.unitCost) && this.isSet(item.units)) {
      item.cost = this.round(item.unitCost * item.units);
    } else {
      item.cost = 0;
    }
    this.itemTaxAmount(item);
    this.itemTotal(item);
    this.subTotalFareByItems(this.expense);
    this.totalFareByItems(this.expense);
  }

  itemTaxAmount = function (item) {
    if (this.isSet(item.tax)) {
      if (item.isAbs) {
        item.taxAmount = this.round(item.tax);
      } else {
        if (item.cost) {
          item.taxAmount = this.round(item.tax * 0.01 * item.cost);
        } else {
          item.taxAmount = 0;
        }
      }
    } else {
      item.taxAmount = 0;
    }
    this.itemTotal(item);
    this.totalFareByItems(this.expense);
    this.totalTaxByItems(this.expense);
  };

  round(value) {
    return Number(Math.round(value + "e" + 2) + "e-" + 2);
  }

  itemTotal(item) {
    if (this.isSet(item.taxAmount) && this.isSet(item.cost)) {
      item.total = this.round(Number(item.taxAmount) + Number(item.cost));
    } else if (this.isSet(item.taxAmount) && !this.isSet(item.cost)) {
      item.total = this.round(item.taxAmount);
    } else if (!this.isSet(item.taxAmount) && this.isSet(item.cost)) {
      item.total = this.round(item.cost);
    } else {
      item.total = 0;
    }
  }

  subTotalFareByItems(expense) {
    let subT = 0;
    if (expense && this.isSet(expense.items)) {
      for (let i = 0; i < expense.items.length; i++) {
        subT = Number(subT) + Number(expense.items[i].cost);
      }
    }
    expense.fare.subTotal = this.round(subT);
  }

  totalFareByItems = function (expense) {
    let allT = 0;
    if (expense && this.isSet(expense.items)) {
      for (let i = 0; i < expense.items.length; i++) {
        allT = this.round(Number(allT) + Number(expense.items[i].total));
      }
    }
    expense.fare.total = this.round(allT);
  };

  totalTaxByItems = function (expense) {
    let tT = 0;
    if (expense && this.isSet(expense.items)) {
      for (let i = 0; i < expense.items.length; i++) {
        tT = this.round(Number(tT) + Number(expense.items[i].taxAmount));
      }
    }
    expense.fare.totalTaxes = this.round(tT);
  };

  totalFareByTax = function (expense) {
    if (expense) {
      if (this.isSet(expense.fare.subTotal)) {
        if (expense.fareIncludeTax) {
          expense.fare.total = expense.fare.subTotal;
          expense.tax_id = null;
        } else {
          let taxObj = null;
          if (this.isSet(expense.tax_id)) {
            for (let i = 0; i < this.taxSlabs.length; i++) {
              if (this.taxSlabs[i]._id == expense.tax_id) {
                taxObj = this.taxSlabs[i];
                break;
              }
            }
          }
          if (taxObj && this.isSet(taxObj.amount)) {
            if (taxObj.isAbs) {
              expense.fare.total =
                Number(expense.fare.subTotal) + Number(taxObj.amount);
            } else {
              expense.fare.total =
                this.round(taxObj.amount * 0.01 * expense.fare.subTotal) +
                this.round(Number(expense.fare.subTotal));
            }
          } else {
            expense.fare.total = 0;
          }
        }
      } else {
        expense.fare.total = 0;
      }
    }
  };

  remove(list, index) {
    if (list && index != null && index != undefined) {
      list.splice(index, 1);
    }
  }

  removeItem(list, index) {
    this.remove(list, index);
    this.subTotalFareByItems(this.expense);
    this.totalFareByItems(this.expense);
    this.totalTaxByItems(this.expense);
  }
}
</script>
<style scoped>
.expense-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  right: 0px;
  font-size: 12px;
}
.image-download {
  position: absolute;
  z-index: 1;
  text-transform: none;
  color: #42a5f5;
  top: 4px;
  left: 4px;
  font-size: 12px;
}
.image-remove {
  position: absolute;
  z-index: 1;
  text-transform: none;
  color: red;
  top: 4px;
  right: -12px;
  font-size: 12px;
}
</style>
